import Page from './index';

export default { path: '/merchantCoin', component: Page };
